export const testimonialSecureCards = [
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606110290_encryption.svg',
    heading: 'No follow-ups required',
    description:
      'Get your own trusted expert anytime, on our platform. Track the progress of your order at the click of a button',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1682419238_storage.svg',
    heading: 'Accuracy Delivered',
    description:
      'We use ISO 27001 certified data centers, which are quarterly VAPT tested and externally audited.',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606308817_privacyaware.svg',
    heading: 'Data security is our priority',
    description:
      'We do not share our or your clients’ data with unaffiliated third parties for their own purposes.',
  },
];

export const testimonials = [
  {
    text: 'Simple, accurate, and easy to understand - these are what describe ClearTax. Thanks to you guys, I filed my return in 6 minutes. The instructions on your portal are so clear that it makes submitting returns easy. Also, thank you for breaking down income tax for me.',
    author: 'Kiran L.',
    place: 'Filed returns in 6 minutes!',
  },
  {
    text: 'The software auto-populated all my capital gains data from the P&L statements and also selected the correct ITR type. ClearTax, thank you for saving so much time and effort. Keep up the great work, team.',
    author: 'VSK Chaitanya',
    place: 'Capital gains from mutual funds and stocks',
  },
  {
    text: 'The software auto-populated all the details from IT Portal and helped me save a lot of time.  I did not have to enter details manually at all.  Never imagined ITR filing to be this easy. ',
    author: 'Sireesha Sai',
    place: 'Data auto-filled from IT Portal',
  },
  {
    text: 'I am a freelancer with income from other sources. The software auto-populated all the details in the appropriate ITR form. All I did was click a few buttons. I have never seen such a tool that gives a seamless experience in filing ITR of any kind. Highly impressed.',
    author: 'Prashant Pant',
    place: 'Freelancer',
  },
  {
    text: "ClearTax lets you upload multiple Form 16s. I switched jobs, and I was confused about how to file. The software made it simple. It's so easy to understand and highly informative. ClearTax has put in a lot of effort to perfect the software and clear any taxpayers' questions. ",
    author: 'Rakesh R.',
    place: 'Had multiple Form 16s-switched jobs',
  },
];

export const pricingStats = [
  {
    id: '₹40 Cr+',
    value: '₹1,050 Cr+',
    text: 'Refunds delivered last year',
  },
];

export const brandingImages = [
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008669_zomato_logo1.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008746_myntralogo1.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008758_flipkart1.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008847_sbicardlogovector011.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008868_marriott_logo.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1683008936_titanlogovector1.svg',
];

export const pricingFaq = [
  {
    header: 'What are the ITR filing plans available with ClearTax?',
    content: (
      <p>
        There are 3 kinds of filing plans available at ClearTax - DIY filing
        plans, CA-assisted plans, and LIVE ITR filing plans. With the DIY filing
        plans, you can file your ITR in just 3 mins and 3 simple steps. The
        CA-assisted plans give you a dedicated tax expert to help you file your
        taxes. With the LIVE filing plan, a Relationship manager will help
        schedule LIVE meetings via Google Meet, Zoom, Microsoft Team, Skype,
        etc. (as per your convenient date & time).
      </p>
    ),
  },
  {
    header: 'Does ClearTax offer CA-assisted income tax filing service?',
    content: (
      <p>
        Yes, we offer CA-assisted plans for all kinds of incomes. Our
        CA-assisted plans for salary and house rent income start from Rs 1299.
        If you have capital gains income, the plan starts from Rs 3999. We also
        have CA-assisted plans for self-employed and professionals starting from
        3999. Crypto traders can also use our expert-assisted plans, starting
        from Rs 2999.
      </p>
    ),
  },
  {
    header: 'What are the benefits of using ClearTax for my ITR filing?',
    content: (
      <div className="font-medium text-base text-font-200">
        <ol className="list-decimal pl-6">
          <li className="pt-4">
            We pre-fill all your details with just one click. Just upload your
            PAN, and voila! You’re done.
          </li>
          <li className="pt-4">
            No need to visit a tax consultant to track your returns. You can do
            it on ClearTax.
          </li>
          <li className="pt-4">
            Our experts will assist you with tax-saving investments based on
            your tax records.
          </li>
        </ol>
      </div>
    ),
  },
  {
    header: 'What information do I need to provide to ClearTax for ITR filing?',
    content: (
      <p>
        All we need is your PAN, Form 16, and Form 26AS. If we require any other
        documents, we will notify you.
      </p>
    ),
  },
  {
    header: 'Can we file ITR without CA?',
    content: (
      <p>
        Yes, you can file your ITR without a CA via our DIY plans. Click{' '}
        <a href="https://cleartax.in/income-tax-efiling#planCard1">here</a> to
        check out the plans.
      </p>
    ),
  },
  {
    header: 'What is assisted filing?',
    content: (
      <div className="font-medium text-base text-font-200">
        <p>
          Get an expert to do your taxes for an individual with all kinds of
          income. No hassle. 100% digital.
        </p>
        <ol className="list-decimal pl-6 pt-10">
          <li>Upload your documents</li>
          <li>Review the computation sheet</li>
          <li>Get ITR verification after e-filing</li>
        </ol>
      </div>
    ),
  },
  {
    header: 'What should be the ITR type for individuals?',
    content: (
      <p>
        ITR-1 to ITR-4 applies to individuals and HUFs with income from salary,
        rent, capital gains, fixed deposit interests, etc. You can choose the
        appropriate ITR form based on the income earned and source of income. If
        you are e-filing with ClearTax, we automatically decide on the correct
        income tax return form.
      </p>
    ),
  },
  {
    header: 'How do I submit my ITR to ClearTax?',
    content: (
      <div className="font-medium text-base text-font-200">
        <ol className="list-decimal pl-6">
          <li className="pt-4">
            Purchase the relevant tax filing plan on our website
          </li>
          <li className="pt-4">
            Upload the required documents to your ClearTax account
          </li>
          <li className="pt-4">
            We assign a tax expert to you who would file returns for you
          </li>
          <li className="pt-4">
            Income tax return is prepared & filed by an expert
          </li>
        </ol>
      </div>
    ),
  },
  {
    header: 'Can we file ITR using ClearTax?',
    content: (
      <p>
        Yes, you can file your taxes using ClearTax. Check out our plans{' '}
        <a href="https://cleartax.in/income-tax-efiling">here</a>.
      </p>
    ),
  },
  {
    header: 'When can I start filing my ITR?',
    content: (
      <p>
        Drop your email ID and phone no.{' '}
        <a href="https://cleartax.in/services/">here</a> and we will notify you
        as soon as the ITR filing services start on ClearTax.
      </p>
    ),
  },
];

export const enum PAGE_VERSION {
  VERSION_A = 'VERSION_A',
  VERSION_B = 'VERSION_B',
  VERSION_C = 'VERSION_C',
}
